import { LoadingButton } from "@mui/lab";
import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import { SpinnerOverlay } from "components/molecules/SpinnerOverlay";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { IdentityActions } from "redux/actions";
import { useAppDispatch } from "redux/configurations/reduxHooks";
import { RootReducer } from "redux/configurations/rootReducer";
import { I18nTranslator, translations } from "utils/i18n";

const generateRandomString = (length = 43) => {
  const possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~";
  let text = "";
  for (let i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  return text;
};

const generateCodeChallenge = async (verifier: string) => {
  const encoder = new TextEncoder();
  const data = encoder.encode(verifier);
  const hash = await crypto.subtle.digest("SHA-256", data);

  return btoa(String.fromCharCode.apply(null, Array.from(new Uint8Array(hash))))
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
};

export const Login = () => {
  const action = useSelector((state: RootReducer) => state.IdentityReducer.action);
  const dispatch = useAppDispatch();

  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = async () => {
    // setError(null);

    const codeVerifier = generateRandomString();
    const codeChallenge = await generateCodeChallenge(codeVerifier);

    localStorage.setItem("pkce_code_verifier", codeVerifier);

    const authUrl = new URL(process.env.REACT_APP_AUTHORIZATION_ENDPOINT);
    authUrl.searchParams.append("response_type", "code");
    authUrl.searchParams.append("client_id", process.env.REACT_APP_CLIENT_ID);
    authUrl.searchParams.append("redirect_uri", process.env.REACT_APP_REDIRECT_URI);
    authUrl.searchParams.append("scope", process.env.REACT_APP_SCOPES);
    authUrl.searchParams.append("code_challenge_method", "S256");
    authUrl.searchParams.append("code_challenge", codeChallenge);
    authUrl.searchParams.append("nonce", generateRandomString(16));

    window.location.assign(authUrl.toString());
  };

  const handleCallback = async (authCode: string) => {
    setIsLoading(true);
    const codeVerifier = localStorage.getItem("pkce_code_verifier");
    localStorage.removeItem("pkce_code_verifier");

    if (!codeVerifier) {
      // setError("Lỗi PKCE: Không tìm thấy code_verifier.");
      setIsLoading(false);
      return;
    }

    try {
      if (authCode) {
        dispatch(IdentityActions.pingAuthenticate.request({ code: authCode, codeVerifier, redirectUri: process.env.REACT_APP_REDIRECT_URI, deviceId: Math.random().toString() }));
      }
    } catch (err: any) {
      console.error(err);
      // setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");

    if (code) {
      handleCallback(code);
    } else if (localStorage.getItem("access_token")) {
      // Tải lại trạng thái nếu có token
    }
    return () => {
      setIsLoading(false);
    };
  }, []);

  return (
    <Box>
      <Grid sx={{ height: "100vh" }} container alignItems="center" justifyContent="center">
        <Card
          sx={{
            margin: "0 20px",
          }}
        >
          <CardContent
            sx={{
              width: 500,
              maxWidth: 500,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <Box sx={{ py: 1, mb: 1 }}>
              <img
                alt="elanco-logo-login"
                src={require("assets/images/logo-primary.png")}
                style={{
                  height: "60px",
                }}
              />
            </Box>

            {/* <Typography
              align="center"
              fontSize={40}
              fontWeight={"bold"}
              sx={{
                mb: 1,
              }}
            >
              MSD WMS
            </Typography> */}
            <Typography variant="h4" align="center" fontWeight={"normal"}>
              {I18nTranslator(translations.login.useMicrosoftAccount)}
            </Typography>
            <Grid container spacing={2} component="form" sx={{ mt: 2 }}>
              <Grid item container justifyContent="center" xs={12}>
                <LoadingButton loading={isLoading} size="large" variant="outlined" sx={{ width: "100%" }} onClick={handleLogin}>
                  {I18nTranslator(translations.login.loginWithMicrosoft)}
                </LoadingButton>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
      <SpinnerOverlay show={action.includes("_REQUEST")} />
    </Box>
  );
};
